<!--
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-17 10:54:50
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2023-02-16 14:46:41
 * @FilePath: \xm-pro-main-des\src\views\proDesMain\desBody\proSettingSubPages\msgNotice\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="selectUser-sty selectUserCtl flex-div"
       :class="[
         hasDel?'item-has-del':'notDel',
         hasError?'item-has-error':'notHasError'
       ]">
    <div class="index-module__select-wrap--EGt10 flex-1" style="position: relative;">
      <a-select
          v-model:value="selValues"
          @change="changSelect"
          :disabled="disabled||item.disabled === true ? true : false"
          mode="multiple"
          label-in-value
          :max-tag-count="effectiveMaxTagCount"
          :size="size||'default'"
          :placeholder="disabled?'':t('请选择') + ` ${item.title || '用户'}`"
          style="width: 100%"
          :not-found-content="fetching ? undefined : null"
          :filter-option="false"
          :options="state.data"
          :show-search="canSearch"
          :show-arrow="false"
          @search="fetchUser"
      >
        <template v-if="fetching" #notFoundContent>
          <a-spin size="small"/>
        </template>

        <template #option="itemObj">
          <div class="user-show-item">
            <user-show-item
                :label="itemObj.label"
                :hasDel="hasDel"
                :item="itemObj"
                :multiple="multiple"
                :value="itemObj.value"
                :remark="itemObj.remark"
                :icon="itemObj.icon"
            />
          </div>
        </template>

        <template #maxTagPlaceholder="omittedValues">
          <QueryFormMaxTagPlaceholder :omitted-values="omittedValues" />
        </template>
      </a-select>

      <div class="sel-icon" v-if="showSelIcon" @click="(e)=>{if(disabled||item.disabled){return};openUseSelWin(e)}">
        <a-tooltip :title="t('点击进行选择')">
          <unordered-list-outlined
              style="color: rgba(0, 0, 0, 0.45); cursor: pointer"
          />
        </a-tooltip>
      </div>
    </div>

    <div class="hasErrorDiv" v-if="hasError&&errorMsg">
      <a-tooltip>
        <template #title>{{errorMsg}}</template>
        &nbsp;<span class="remix-icon ri-error-warning-line"></span>
      </a-tooltip>
    </div>

    <user-sel-modal
        :multiple="multiple"
        :hasDel="hasDel"
        :account="account"
        :roleName="roleName"
        :closeTopQuery="closeTopQuery"
        :selUserRecords="selUserRecords"
        :configs="item"
        :allUser="allUser"
        @selRecords="selRecords"
        @handleCancel="handleCancel"
        v-if="modalVisible"
        v-model:visible="modalVisible"
    />
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "selectUserCtl",
});
</script>

<script lang="ts" setup>
import UserShowItem from "./components/user-show-item.vue";
import {UnorderedListOutlined} from "@ant-design/icons-vue";
import {Select as aSelect, Spin as aSpin} from "ant-design-vue";
import {useI18n} from "vue-i18n";
import {useSelUserHooks} from "./hooks/useSelUserHooks";
import {useSearchSel} from "./hooks/useSearchSel";
import UserSelModal from "./components/user-sel-modal.vue";
import {resolvePeoplePickerMaxTagCount} from "@/main-page-form/common/queryFormSelectTagUtils";
import QueryFormMaxTagPlaceholder from "@/main-page-form/common/QueryFormMaxTagPlaceholder.vue";

interface propTypes {
  model:any;
  editorRowFlag:boolean;
  closeTopQuery:boolean;
  errorMsg:string;
  hasError:boolean;
  size: string,
  hasDel:boolean;
  ctlFromType: string,
  value: any,
  multiple: boolean,
  account: boolean,
  readOnlyText:boolean;
  disabled: boolean,
  allUser:boolean;
  roleName: '',
  text: string,
  //选项信息
  item: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  model:{},
  editorRowFlag:false,
  closeTopQuery:false,
  errorMsg:'',
  hasDel:true,
  readOnlyText:false,
  hasError:false,
  account: false,
  size: 'default',
  allUser:false,
  text: '',
  item: {},
  ctlFromType: '',
  value: '',
  multiple: false,
  disabled: false,
  roleName: '',
});

interface Data {
  [key: string]: unknown;
}

interface SetupContext {
  //这里还有其他的，为了避免混淆，就不写了。
  emit: (event: string, ...args: unknown[]) => void;
}

const {value, multiple, disabled, roleName, model, item, ctlFromType}: any = toRefs(propsPage);

const effectiveMaxTagCount = computed(() =>
  resolvePeoplePickerMaxTagCount(unref(multiple), unref(item)?.maxTagCount),
);

/** 默认 more-search-list 隐藏列表图标；仅当 item.showSelIcon===true 时显式开启（由筛选面板传入） */
const showSelIcon = computed(() => {
  if (unref(disabled) || unref(item)?.disabled) {
    return false;
  }
  if (unref(item)?.showSelIcon === true) {
    return true;
  }
  return unref(ctlFromType) !== 'more-search-list';
});

const emit = defineEmits(['update:value', 'update:text', 'confirmOk','handleCancel']);

const handleCancel=function () {
  emit('handleCancel',{});
}
const {t} = useI18n();
//打开选人组件hook
const {openUseSelWin, modalVisible} = useSelUserHooks();
//搜索人 选人方法
const {
  systemSel,
  fetching,
  state,
  fetchUser,
  selRecords,
  selValues,
  changSelect,
  selUserRecords,
  initSelValues,
} = useSearchSel(multiple, value, emit,null,model,unref(item).multipleRecords);

// 计算是否允许搜索：单选或多行新增模式下，如果有已选数据则不允许搜索（只读效果）
const canSearch = computed(() => {
  const baseDisabled = disabled?.value || item?.value?.disabled === true;
  if (baseDisabled) {
    return false;
  }
  const isSingleSelect = !unref(multiple);
  const isMultipleRecords = unref(item)?.multipleRecords;
  const hasData = unref(selValues) && unref(selValues).length > 0;
  // 单选或多行新增模式下有数据时禁止搜索输入
  return !((isSingleSelect || isMultipleRecords) && hasData);
});


watch(value, (newVal:any) => {
  if (newVal == null || newVal === '') {
    initSelValues('');
    return;
  }
  //如果是系统选中 导致的变更 则不进行多次初始化
  if (unref(systemSel)) {
    systemSel.value = false;
    return;
  }
  if (Array.isArray(newVal)) {
    initSelValues(newVal.join(";"));
  } else {
    initSelValues(newVal);
  }
});
const clearRecords = function () {
  initSelValues('');
}

const setRecords = function (records: any[]) {
  selUserRecords.value = unref(records);
}


//如果存在默认值
if (unref(value) && unref(value).length > 0) {
  nextTick(()=>{
    initSelValues(unref(value));
  })
}

defineExpose({clearRecords, openUseSelWin, setRecords});
</script>

<style type="text/css" lang="less">
.selectUser-sty {
  position: relative;
  flex: 1;

  &.notDel{
     .ant-select-selection-item-remove{
      display: none;
    }
  }
  // 隐藏下拉箭头
  .ant-select-arrow {
    display: none !important;
  }
  .sel-icon {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 10px;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
